import * as React from "react";
import { RouteComponentProps } from "react-router";
import { RioArrayHelpers, RioCheckbox, RioForEach, RioIf, RioInput, RioModal, RioResources, RioSelect, RioValidator } from "rio.react.all";
import { OrganisationApi } from "../apiLayer/OrganisationApi";
import { UserApi } from "../apiLayer/UserApi";
import { OrganisationApiModel } from "../apiModels/OrganisationApiModel";
import { UserApiModel } from "../apiModels/UserApiModel";
import { UserGroupApiModel } from "../apiModels/UserGroupApiModel";
import { SelectOption } from "../helpers/SelectOption";

interface IUserAddUpdateParams {
    userId: string;
}

interface IUserAddUpdateProps extends Partial<RouteComponentProps<IUserAddUpdateParams>> {
    userId: string;
    onClose: () => void;
}

interface IUserAddUpdateState {
    // Bindings
    user: UserApiModel;
    loading: boolean;
    error: boolean;
    passwordResetSent: boolean;
    availableGroups: UserGroupApiModel[];
    organisationOptions: Array<OrganisationApiModel>;
}

export class UserAddUpdateModal extends React.Component<IUserAddUpdateProps, IUserAddUpdateState> {

    constructor(props: Readonly<IUserAddUpdateProps>) {
        super(props);
        this.state = {
            user: null,
            loading: true,
            error: false,
            passwordResetSent: false,
            availableGroups: [],
            organisationOptions: []
        };
        if (props.userId) {
            this.userId = parseInt(this.props.userId);
        }
    }

    private userId: number;
    private validator = new RioValidator();

    componentDidMount() {
        this.getUser();
        this.getOrganisationOptions();
    }

    getUser() {
        if (this.userId == 0 || isNaN(this.userId)) {
            var newUser = new UserApiModel();
            newUser.groups = [];
            newUser.userID = 0;
            newUser.locked = false;
            newUser.hasAccess = false;
            this.setState({
                user: newUser
            });
            UserApi.getAvailableGroups()
                .then(response => {
                    for (var i = 0; i < response.length; i++) {
                        //selected will be false for all roles since it's a new user.
                        response[i].selected = false;
                    }
                    this.setState({
                        availableGroups: response
                    });
                });
        } else {
            UserApi.getUser(this.userId)
                .then(response => {
                    this.setState({
                        user: response,
                        loading: false
                    });

                    UserApi.getAvailableGroups().then(response => {
                        for (var i = 0; i < response.length; i++) {
                            //if the user belongs to the group, select it
                            response[i].selected = RioArrayHelpers.any(this.state.user.groups, (x) => x.userGroupID == response[i].userGroupID)
                        }
                        this.setState({
                            availableGroups: response
                        });
                    });
                })
                .catch(errors => {
                    this.setState({
                        error: true,
                        loading: false
                    });
                });
        }
    }

    getOrganisationOptions() {
        OrganisationApi.getOrganisations()
            .then(response => {
                this.setState({
                    organisationOptions: response
                });
            });
    }

    render() {

        return (
            <React.Fragment>
                <RioModal visible={true} onCancel={() => this.handleModalCloseClicked()} className="large">
                    <div className="userDetailsArea">
                        <div className="screenTitle">
                            <h1>User</h1>
                        </div>

                        <div className="form">
                            <div className="horizontalFlex">
                                <label className="mandatory">{RioResources.find("FirstName").text}</label>
                                <RioInput name="FirstName" type="text" value={this.state.user && !!this.state.user.firstName ? this.state.user.firstName : ""}
                                    onChange={(e) => this.handleFirstNameChanged(e)} validator={this.validator}
                                    validations={{ required: true }} />
                            </div>
                            <div className="horizontalFlex">
                                <label className="mandatory">{RioResources.find("LastName").text}</label>
                                <RioInput name="LastName" type="text" value={this.state.user && !!this.state.user.lastName ? this.state.user.lastName : ""}
                                    onChange={(e) => this.handleLastNameChanged(e)} validator={this.validator}
                                    validations={{ required: true }} />
                            </div>
                            <div className="horizontalFlex">
                                <label className="mandatory">{RioResources.find("Email").text}</label>
                                <RioInput name="Email" type="text" value={this.state.user && !!this.state.user.email ? this.state.user.email : ""}
                                    onChange={(e) => this.handleEmailChanged(e)} validator={this.validator}
                                    validations={{ required: true }} />
                            </div>
                            <div className="horizontalFlex">
                                <label className="mandatory">{RioResources.find("Organisation").text}</label>
                                <RioSelect<OrganisationApiModel>
                                    name="Organisation"
                                    items={this.state.organisationOptions}
                                    value={!!this.state.user && !!this.state.user.organisationID ? this.state.organisationOptions.filter(x => x.organisationID == this.state.user.organisationID) : []}
                                    keySelector={(item: OrganisationApiModel) => { return item.organisationID.toString() }}
                                    descriptionSelector={(item: OrganisationApiModel) => { return item.name }}
                                    onSuggestionSelected={(value: OrganisationApiModel) => { this.handleOrganisationSelected(value) }}
                                    validator={this.validator}
                                    validations={{ required: true }}
                                    keepOptionsOpenOnSelected={false}
                                />
                            </div>
                            <div className="horizontalFlex">
                                <label>{RioResources.find("Locked").text}</label>
                                <RioCheckbox checked={this.state.user ? this.state.user.locked : false}
                                    onChange={() => this.handleLockedChanged()} />
                            </div>
                            <div className="horizontalFlex">
                                <label>{RioResources.find("HasAccess").text}</label>
                                <RioCheckbox checked={this.state.user ? this.state.user.hasAccess : false}
                                    onChange={() => this.handleActiveChanged()} />
                            </div>
                            <RioIf condition={this.state.availableGroups.length > 0} then={
                                <div className="horizontalFlex">
                                    <label>{RioResources.find("RolePermissions").text}</label>
                                    <div className="verticalFlex userGroupCheckBoxes">

                                        <RioForEach items={this.state.availableGroups} perform={(item: UserGroupApiModel) => {
                                            return <div className="horizontalFlex userGroupCheck" key={item.userGroupID}>
                                                <RioCheckbox checked={item.selected}
                                                    onChange={() => this.handleGroupSelectedChanged(item)} key={item.userGroupID} />
                                                <label onClick={() => this.handleGroupSelectedChanged(item)}>{item.userGroupName}</label>

                                            </div>;
                                        }} />
                                    </div>
                                </div>
                            } />

                        </div>

                        <div className="horizontalFlex formButtons">
                            <button onClick={() => this.cancel()}>{RioResources.find("Cancel").text}</button>
                            <button onClick={() => this.save()}>{RioResources.find("Save").text}</button>
                        </div>
                    </div>
                </RioModal>
            </React.Fragment>
        );
    }

    renderTitle() {
        if (!this.state.user) {
            return "";
        }
        if (this.state.user.userID == 0) {
            return (<h1>New User</h1>);
        }
        return (<h1>Edit User</h1>);
    }

    //renderPasswordReset() {
    //    if (this.state.passwordResetSent) {
    //        return (<p className="passwordResetSent">{RioResources.find("PasswordResetSent").text}</p>);
    //    }
    //    if (!this.state.user || this.state.user.userID == 0 || this.state.loading) {
    //        return ""; //Can't reset password of a new user
    //    }
    //    return (<button onClick={() => this.sendPasswordReset()}>{RioResources.find("SendPasswordReset").text}</button>);
    //}

    //sendPasswordReset() {
    //    this.setState({
    //        loading: true
    //    }, () => {
    //        UserApi.passwordReset(this.state.user.email, () => {
    //            this.setState({
    //                loading: false,
    //                passwordResetSent: true
    //            });
    //        });
    //    });
    //}

    cancel() {
        this.props.onClose();
    }

    save() {
        this.setState({
            loading: true
        });
        UserApi.postUser(this.state.user)
            .then(response => {
                this.setState({
                    loading: false
                });
                this.props.onClose();
            })
            .catch(errors => {
                this.validator.clearModelErrors(this);
                this.validator.addModelErrors(this, errors.errors);
                this.setState({
                    error: true,
                    loading: false
                });
            });
    }

    handleModalCloseClicked() {
        this.props.onClose();
    }

    handleFirstNameChanged(event: React.ChangeEvent<HTMLInputElement>) {
        this.state.user.firstName = event.target.value;
        this.forceUpdate();
    }

    handleLastNameChanged(event: React.ChangeEvent<HTMLInputElement>) {
        this.state.user.lastName = event.target.value;
        this.forceUpdate();
    }

    handleEmailChanged(event: React.ChangeEvent<HTMLInputElement>) {
        this.state.user.email = event.target.value;
        this.forceUpdate();
    }

    handleLockedChanged() {
        this.state.user.locked = !this.state.user.locked;
        this.forceUpdate();
    }

    handleActiveChanged() {
        this.state.user.hasAccess = !this.state.user.hasAccess;
        this.forceUpdate();
    }

    handleGroupSelectedChanged(item: UserGroupApiModel) {
        item.selected = !item.selected;
        this.forceUpdate();
        if (item.selected) {
            this.state.user.groups.push(item);
        }
        else {
            for (var i = 0; i < this.state.user.groups.length; i++) {
                if (this.state.user.groups[i].userGroupID == item.userGroupID) {
                    this.state.user.groups.splice(i, 1);
                }
            }
        }
    }

    handleOrganisationSelected(item: OrganisationApiModel) {
        this.state.user.organisationID = item.organisationID;
        this.forceUpdate();
    }
}

